// © Microsoft Corporation. All rights reserved.

import { DesignSystem, highContrastSelector, isDarkMode, neutralFillActive, neutralFillRest, neutralFocus, neutralForegroundHint } from "@microsoft/fast-components-styles-msft";
import { enums, getEmojiStylesByWidth } from "@msnews/social-utils";

import { applyLocalizedProperty } from "@microsoft/fast-jss-utilities";

export const SocialBarPanelStyles = (config: DesignSystem) => ({
    socialBarPanelContainer: {
        "touch-action": "none",
        display: "flex !important",
        "align-items": "center",

        "& .vertical-line": {
            "font-size": "10px",
            [applyLocalizedProperty("margin-right", "margin-left", config.direction)]: "13px",
            [applyLocalizedProperty("margin-left", "margin-right", config.direction)]: "-2px",
            color: neutralFocus
        },

        "& div.emoji-icon": {
            ...getEmojiStylesByWidth(16),
            transition: "none"
        },

        "& > .cwt-icon": {
            "font-size": "16px",
            padding: applyLocalizedProperty("6px 2px 6px 8px", "6px 8px 6px 2px", config.direction),
            margin: applyLocalizedProperty("0 7px 0 0", "0 0 0 7px", config.direction),
            color: isDarkMode(config) ? "#F5F5F5" : "#262626",
            "border-radius": "4px",

            "& + .cwt-visible-on-focus:focus": {
                margin: applyLocalizedProperty("0 6px 0 -8px", "0 -8px 0 6px", config.direction)
            },

            "&.cwt-hide": {
                display: "none",
                "pointer-events": "none",
                "touch-events": "none"
            },

            "& .cwt-icon-label": {
                "font-size": "13px",
                padding: "0 6px",

                "& a.cwt-link:not([href])": {
                    color: "unset"
                }
            },

            "&.cwt-active-reaction .cwt-icon-label": {
                "font-weight": "600"
            },

            '&[role="button"]': {
                "&:hover, &.highlight": {
                    background: neutralFillRest
                },
                "&:active": {
                    background: neutralFillActive
                }
            }
        },

        "&& > .cwt-icon": {
            [highContrastSelector]: {
                color: "buttontext"
            }
        },

        "& .cwt-reply-btn.cwt-icon": {
            "& .cwt-icon-vector": {
                "margin-top": "2px"
            }
        },

        "& .cwt-icon.emoji-button": {
            padding: "6px",
            "font-size": "20px"
        },

        // 'RATING LABELS'
        "& > .cwt-icon .cwt-icon-label.cwt-red-reaction": {
            color: isDarkMode(config) ? "#FF948F" : "#E02F19"
        },
        "& > .cwt-icon .cwt-icon-label.cwt-yellow-reaction": {
            color: isDarkMode(config) ? "#FF9333" : "#BD5B00"
        },

        ["&." + enums.responsiveLevels.MobilePopup]: {
            "& > .cwt-icon:hover, .cwt-icon-label:hover ": {
                color: neutralForegroundHint
            }
        }
    },
    contentReactionCounts: {
        display: "flex !important",
        "align-items": "center",
        "font-size": "16px !important",
        [applyLocalizedProperty("margin-right", "margin-left", config.direction)]: "12px",

        "& > .cwt-icon": {
            padding: "0",
            "font-size": "16px !important",
            "align-items": "flex-start",

            "& .cwt-icon-label": {
                padding: "0 3px",
                "font-size": "13px",
                "margin-top": "0"
            },

            "& .cwt-icon-vector": {
                [applyLocalizedProperty("margin-right", "margin-left", config.direction)]: "4px",
                "margin-top": "2px",
                "&:last-child": {
                    [applyLocalizedProperty("margin-right", "margin-left", config.direction)]: "0"
                }
            }
        }
    }
});